// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3HVzx","signatureBlock":"Footer_signatureBlock__rgJZf","signature":"Footer_signature__2g3-6"};